<script>
// import _ from 'lodash'
import { mapGetters } from 'vuex'
import {
  questionPageMethods,
  userAnswerMethods,
  assessmentRunSessionMethods,
} from '@state/helpers'
import GeneralDataForm from './general-data-form.vue'
import SurveyHeader from './survey-header.vue'
import PsychosocialRiskFactorsForm from './psychosocial-risk-factors-form.vue'
import StressForm from './stress-form.vue'
export default {
  name: 'QuestionsIndex',
  components: { GeneralDataForm, SurveyHeader, PsychosocialRiskFactorsForm, StressForm },

  props: {
    assessment: {
      type: Object,
      required: true,
    },
    assessmentCompletedSuccessfully: {
      type: Function,
      required: true,
    },
  },

  data() {
    return {
      loadingPageData: false,
      currentForm: {},
      selectorQuestionValue: null,
      currentUser: null,
      modalDeleteIntraocupational:false,
      ant:null,
      message:'',
      isFirst:null,
      question_ids:null,
      initialValue:null
    }
  },

  computed: {
    ...mapGetters({
      pageData: 'assessment/questionPagination/page',
      assessmentRunSession:
        'assessment/assessmentRunSession/assessmentRunSession',
    }),
    // should return 'a' or 'b'
    psychosocialRiskFormat() {
      if (!this.currentForm['16']) return null
      // format: [questions ids]
      const parameters = {
        a: ['33', '34'],
        b: ['35', '36'],
      }
      return Object.entries(parameters)
        .map(([key, value]) =>
          value.includes(this.currentForm['16']) ? key : null
        )
        .filter(Boolean)[0]
    },
  },

  watch: {
    pageData(val) {
      this.generateForm()
      // get position question: id = 16
      const questionId = val.id === 6 ? '16' : ''
      this.getUserAnswers(questionId)
    },
  },

  mounted() {
    this.getQuestions()
  },

  methods: {
    ...assessmentRunSessionMethods,
    ...questionPageMethods,
    ...userAnswerMethods,
    async getCurrentAssessmentRunSession() {
      let isValid = false
      Object.keys(this.currentForm).forEach((key) => {
        if (['1', '2'].includes(key)) isValid = true
      })
      if (!isValid) return
      this.loadingPageData = true
      try {
        const dataCurrent = await this.findCurrentRunSession({
          identification: this.currentForm['2'],
          assessment_id: this.assessment.id,
        })

        this.currentUser = dataCurrent
        this.loadingPageData = false
        let param = 0
        param = this.currentUser.state == 5 ? 5:2
        this.onSaveAnswers(param)
      } catch (error) {
        this.loadingPageData = false
        this.$axios_error_noty(error, this)
      }
    },

    resetInfo() {
      this.selectorQuestionValue = null
    },

    async getQuestions(url = null, pageId = 1) {
      console.log(this.pageData.id)
      try {
        this.loadingPageData = true
        await this.getQuestionPage({ url, pageId })
        this.resetInfo()
        this.loadingPageData = false
      } catch (error) {
        this.$axios_error_noty(error, this)
        this.loadingPageData = false
      }
    },

    async getUserAnswers(questionsIds = '') {
      if (!this.assessmentRunSession.url) return
      if (!questionsIds) {
        questionsIds = this.pageData.questions_details
          .map((q) => q.id)
          .join(',')
      }
      this.loadingPageData = true
      try {
        const { data } = await this.fetchUserAnswers({
          page_size: 99,
          assessment_run_session: this.assessmentRunSession.id,
          question__in: questionsIds,
        })
        this.question_ids = questionsIds
        data.results.forEach((el) => {
          this.currentForm[el.question_detail.id] = el.answer
        })
        this.isFirst = this.currentForm[16] != null && this.currentForm[16] != '' ? false:true
        this.initialValue = this.currentForm[16] != null && this.currentForm[16] != '' ? this.currentForm[16]:null
        this.loadingPageData = false
      } catch (error) {
        this.loadingPageData = false
        this.$axios_error_noty(error, this)
      }
    },

    validatedAnsweredQuestions() {
      let currentForm = this.currentForm
      let questionsDetails = this.pageData.questions_details
      if (this.selectorQuestionValue === 2) {
        // clean current form if value = 2
        currentForm = {}
        Object.entries(this.currentForm).forEach(([key, value]) => {
          if (value) currentForm[key] = value
        })
        questionsDetails = questionsDetails.filter(
          (q) => q.id === parseInt(Object.keys(currentForm)[0], 10)
        )
      }
      return questionsDetails.map((q) => ({
        question_id: q.id,
        question_url: q.url,
        answer: currentForm[q.id],
      }))
    },

    async onSaveAnswers(assessmentRunSessionState = 2) {
      if (!this.assessmentRunSession.url) return
      this.loadingPageData = true
      const payload = {
        assessment_run_session: {
          ...this.assessmentRunSession,
          state: assessmentRunSessionState,
        },
        answered_questions: this.validatedAnsweredQuestions(),
      }
      try {
        const { status } = await this.saveMultipleAnswers(payload)
        if (status === 200) {
          this.loadingPageData = false
          if (!this.pageData.next_page && assessmentRunSessionState === 5) {
            this.assessmentCompletedSuccessfully()
            return
          }
          this.getQuestions(this.pageData.next_page)
        }
      } catch (error) {
        this.loadingPageData = false
        this.$axios_error_noty(error, this)
      }
    },

    onPreviousPage() {
      if (this.pageData.id === 27 && this.psychosocialRiskFormat === 'b') {
        this.getQuestions(null, 26)
        return
      }
      this.getQuestions(this.pageData.previous_page)
    },

    onNextPage() {
      switch (this.pageData.id) {
        case 1:
          this.getCurrentAssessmentRunSession()
          break
        case 27:
        case 31:
          this.getQuestions(this.pageData.next_page)
          break
        case 6:
          if (this.psychosocialRiskFormat === 'b') {
            this.getQuestions(null, 18)
            break
          }
          this.getQuestions(this.pageData.next_page)
          break
        case 32:
          // param = assessment run session state
          this.onSaveAnswers(5)
          break
        default:
          let param = 0
          param = this.currentUser.state == 5 ? 5:2
          this.onSaveAnswers(param)
          //Seleccionar página.
          // if (this.pageData.id < 14) {
            // this.getQuestions(null, 32)
          // }
          break
      }
    },

    generateForm(form = {}) {
      this.pageData.questions_details.forEach((el) => {
        form[el.id] = form[el.id] || ''
      })
      this.currentForm = form
    },

    // selector value from psycosocial risk factors form
    setSelectorQuestionValue(selectorQuestionValue = null) {
      // 1 = Si, 2 = No
      this.ant = this.selectorQuestionValue
      this.selectorQuestionValue = selectorQuestionValue
      if (this.pageData.id == 15 || this.pageData.id == 16){
          if(this.ant==1){
            if(this.selectorQuestionValue !== this.ant){
              this.modalDeleteIntraocupational = !this.modalDeleteIntraocupational
            }
          }
      }
    },
    DeleteIntraocupationalMethod(){
      if(this.pageData.id == 15 || this.pageData.id == 16){
        const obj = {'question_ids':this.question_ids,'assessment_run_session_id':this.currentUser.id}
        this.loadingPageData = !this.loadingPageData
        this.deleteIndependentQuestion(obj).finally(response=>{
          this.loadingPageData = !this.loadingPageData
          this.generateForm()
        })
        //return 6 intra laboral
        // this.getQuestions(null,6)
      }
    },
    CancelDeleteIntraocupationalMethod(){
      
      this.selectorQuestionValue = this.ant
    }
  },
}
</script>

<template>
  <div>
  <b-modal 
  v-model="modalDeleteIntraocupational" 
  @ok="DeleteIntraocupationalMethod"
  @cancel="CancelDeleteIntraocupationalMethod"
  title="¿Seguro que desea cambiar la respuesta?">
  <p>Si cambia esta opción, se eliminarán las respuestas antes dadas.</p>
  </b-modal>
    <div class="mb-3">
      <b-row>
        <b-col sm="6">
          <img
            src="./logos/ministerioproteccion-removebg-preview.png"
            alt="image"
          />
        </b-col>
        <b-col sm="6">
          <div class="float-right">
            <img
              src="./logos/universidadjaveriana-removebg-preview.png"
              alt="image"
            />
          </div>
        </b-col>
      </b-row>
    </div>
    <div v-if="loadingPageData" class="text-center my-4">
      <b-spinner class="align-middle mr-1"></b-spinner>
      <strong>Cargando</strong>
    </div>
    <div v-else>
      <!-- ASSESSMENT RUN SESSION
      <pre>
        {{assessmentRunSession}}
      </pre> -->

      <!-- PAGE DATA
      <pre>
        {{pageData.survey_detail}}
      </pre> -->
      <SurveyHeader :page-id="pageData.id" />
      <GeneralDataForm
        v-if="pageData.id < 7"
        :assessment="assessment"
        :current-form="currentForm"
        :page-data="pageData"
        :is-first="isFirst"
        :initial-value="initialValue"
        :current-user="currentUser"
      />
      <PsychosocialRiskFactorsForm
        v-else-if="pageData.id >= 7 && pageData.id < 32"
        :current-form="currentForm"
        :page-data="pageData"
        @selectorQuestionValue="setSelectorQuestionValue($event)"
      />
      <StressForm
        v-else-if="pageData.id >= 32"
        :current-form="currentForm"
        :page-data="pageData"
      />
        <!-- @selectorQuestionValue="setSelectorQuestionValue($event)" -->
    </div>

    <b-row class="border-top pt-2">
      <b-col>
        <div v-if="pageData.previous_page">
          <b-button :disabled="loadingPageData" @click="onPreviousPage">
            <i class="fas fa-chevron-circle-left mr-1"></i>
            <span>Regresar</span>
          </b-button>
        </div>
      </b-col>
      <b-col>
        <div>
          <b-button
            variant="primary"
            class="float-right"
            :disabled="loadingPageData"
            @click="onNextPage"
          >
            <span>Guardar y continuar</span>
            <i class="fas fa-chevron-circle-right ml-1"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>